import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/matters/settings/phase-projects")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => {
    const pageNumber = Number(search.pageNumber);
    const pageSize = Number(search.pageSize);
    return {
      editor: typeof search.editor === "string" ? search.editor : undefined,
      edit: search.edit === true || search.edit === "true" ? true : undefined,
      q: typeof search.q === "string" ? search.q : undefined,
      lifecycle:
        search.lifecycle === "Draft" ||
        search.lifecycle === "Active" ||
        search.lifecycle === "Archived"
          ? search.lifecycle
          : undefined,
      incidentTypeId:
        typeof search.incidentTypeId === "string"
          ? search.incidentTypeId
          : undefined,
      pageNumber:
        Number.isInteger(pageNumber) && pageNumber > 1 ? pageNumber : undefined,
      pageSize:
        [10, 25, 50, 100].includes(pageSize) && pageSize !== 25
          ? pageSize
          : undefined,
    };
  },
});

function RouteComponent() {
  const { hasPagePermission } = useUser();
  const { editor, edit } = Route.useSearch();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.mattersSettingsPhaseProjects)) {
    return <GlobalNotAuthorized />;
  }

  if (editor) {
    return (
      <PhaseProjectEditorPage
        projectId={editor === "new" ? undefined : editor}
        startEditing={edit}
      />
    );
  }
  return <MatterPhaseSettingsView />;
}
import MatterPhaseSettingsView from "@/components/features/settings/defaults/matter-phase-projects/MatterPhaseSettingsView";
import { PhaseProjectEditorPage } from "@/components/features/settings/defaults/matter-phase-projects/PhaseProjectEditorPage";
